import './style.css';

angular.module('app.components')

.component('redirecionamentos', {
   bindings: {
       redirecionamentos: '=',
       de: '='
   },
   template: require('./redirecionamentos.html')
})


//////////////////
// WEBPACK FOOTER
// ../Projecao.ContactCenter.WebApp.Compartilhado/components/redirecionamentos/index.js
// module id = 318
// module chunks = 1